import { useMutation } from '@tanstack/react-query';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';

//TODO: rename function
function useHandleRoundAddedFromDiscover() {
  const { mutate, isSuccess, isLoading } = useMutation(
    ({ slides }: { slides: Slide[] }) =>
      BackendService.instance.discover.onDiscoverRoundsAdded(slides),
    {
      retry: 5,
    },
  );

  return {
    handleSlideAddedFromDiscover: mutate,
    isSuccess,
    isLoading,
  };
}

export default useHandleRoundAddedFromDiscover;
